// Campus photo for /colleges/morehouse-college: CC BY-SA 4.0, by Marc Merlin, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASamuel_T._Graves_Hall_at_Morehouse_College%2C_June_2015.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/morehouse-college/; credited under the photo.
const photo = {
    "slug": "morehouse-college",
    "alt": "Samuel T. Graves Hall, a red brick building with a central tower, behind a statue and shade trees at Morehouse College in Atlanta",
    "src": "/colleges/morehouse-college/campus-1600.webp",
    "srcSmall": "/colleges/morehouse-college/campus-800.webp",
    "srcMid": "/colleges/morehouse-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/morehouse-college/og.jpg",
    "title": "Samuel T. Graves Hall at Morehouse College, June 2015",
    "author": "Marc Merlin",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASamuel_T._Graves_Hall_at_Morehouse_College%2C_June_2015.jpg",
    "read": "2026-10-01"
};

export default photo;
